/* Regional delivery line on product cards AND in the cart (drawer + cart page).

   Red Stag routes on destination state: the 13 western states ship from SLC,
   everything else from SWT. Cards render the sitewide worst case server side
   and carry both warehouse quotes as data attributes; this swaps in the one
   that will actually serve the visitor, so a card and its product page quote
   the same number.

   Shares the localStorage record the product page writes, so a shopper who
   picked their state by hand keeps that pick everywhere, and a lookup only
   ever happens once a week. Anyone we cannot place - lookup blocked, offline,
   non-US - keeps the worst case that is already on the page. A regional quote
   is only ever faster, never slower, so nothing here can promise a speed we
   are unable to honour. */
(function () {
  var WEST = ['AK','AZ','CA','CO','HI','ID','MT','NV','NM','OR','UT','WA','WY'];
  var LADDER = ['2-3 days','3-5 days','5-7 days','7-10 days','10-14 days','2-3 weeks','3-4 weeks','4-6 weeks'];
  var KEY = 'ks_delivery_region';
  var TTL = 7 * 24 * 60 * 60 * 1000;   // a guess goes stale weekly; a manual pick never does
  var SEL = '.product-card__delivery-text[data-ks-west], .product-card__delivery-text[data-ks-east]';
  var CART_SEL = '[data-ks-cart-delivery]';
  /* USPS codes (50 states + DC) - anything else keeps the plain "Delivery" label. */
  var US = ['AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'];

  /* Separate add-ons grouped by window, fastest window first: one name, two A-Z joined
     with ' + ', three or more = 'N add-ons' (Keelan 10-14). Same as the Liquid. */
  function groupAddons(list) {
    var groups = [];
    for (var i = 0; i < LADDER.length; i++) {
      var names = [];
      for (var j = 0; j < list.length; j++) {
        if (list[j].q === LADDER[i] && names.indexOf(list[j].label) === -1) names.push(list[j].label);
      }
      if (names.length) groups.push({ q: LADDER[i], n: names.length, name: names.length > 2 ? names.length + ' add-ons' : names.sort().join(' + ') });
    }
    return groups;
  }

  var region = null;      // state code once placed
  var detecting = false;

  function read() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!d || !d.code) return null;
      if (!d.manual && (!d.ts || Date.now() - d.ts > TTL)) return null;
      return d;
    } catch (e) { return null; }
  }

  function apply() {
    if (!region) return;
    var west = WEST.indexOf(region) !== -1;
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var q = el.getAttribute(west ? 'data-ks-west' : 'data-ks-east');
      if (LADDER.indexOf(q) === -1) continue;
      el.textContent = 'Delivery in ' + q;
      el.classList.toggle('product-card__delivery-text--fast', q === '2-3 days');
    }
    applyCart(west);
  }

  /* The cart's "Delivery" line (09-27). Per line, the PRODUCT PAGE's rule: this region's
     quote (falling back to sitewide), and the backorder window only when this region's
     units (units_west/_east, falling back to units_available = the MIN) > 0 and qty exceeds it (units 0 is ignored, like the PDP); slowest line wins;
     a freight cart follows the freight map (2-3/3-5 -> 5-7, 5-7 -> 7-10, 7-10 -> 10-14)
     and is labelled "(Freight)"; green only when every line
     is 2-3 days (5-7 counts for ltl-only), or a freight cart that lands on 5-7. Each
     separate add-on gets its own row below ("Monitor Stand   3-4 weeks"). The
     server's worst case stays the default, and this never shows anything slower. */
  function applyCart(west) {
    var nodes = document.querySelectorAll(CART_SEL);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      /* "Delivery to ID" (Keelan 09-28). Set before the value's only-ever-faster guard. */
      var lab = el.parentNode.querySelector('[data-ks-cart-delivery-label]');
      var text = US.indexOf(region) !== -1 ? 'Delivery to ' + region : 'Delivery';
      if (lab && lab.textContent !== text) lab.textContent = text;
      var lines = el.parentNode.querySelectorAll('[data-ks-cart-line]');
      if (!lines.length) continue;
      var worst = 0, soloWorst = 0, bumpAny = false, allFast = true, held = [];
      for (var j = 0; j < lines.length; j++) {
        var l = lines[j];
        /* Attached add-ons never hold up delivery (Keelan 10-02), decided server side:
           'skip' = a warehouse has it, left out; 'separate' = neither has it, named on its own.
           Both are held aside until we know every main line is fast (below). */
        var rule = l.getAttribute('data-rule');
        var qty = parseFloat(l.getAttribute('data-qty')) || 0;
        /* This region's warehouse count, as on the PDP (ksRegionalUnits); MIN fallback. */
        var units = l.getAttribute(west ? 'data-units-west' : 'data-units-east');
        if (units === null || units === '' || isNaN(parseFloat(units))) units = l.getAttribute('data-units');
        /* EXACTLY the product page's rule (updateDeliveryDisplay, Keelan 09-27): the
           regional quote, else sitewide; the backorder window only when units > 0 AND
           qty > units. units 0 is ignored, as it is on the PDP. */
        var q = l.getAttribute(west ? 'data-west' : 'data-east');
        if (LADDER.indexOf(q) === -1) q = l.getAttribute('data-sitewide');
        var u = parseFloat(units);
        if (!isNaN(u) && u > 0 && qty > u && l.getAttribute('data-backorder')) q = l.getAttribute('data-backorder');
        if (rule === 'skip' || rule === 'separate') {
          held.push({ rule: rule, q: q, label: l.getAttribute('data-label') });
          continue;
        }
        /* Freight on its own (data-solo): keeps its product-page window, never bumped (Keelan 11-02). */
        if (l.getAttribute('data-solo') === '1') soloWorst = Math.max(soloWorst, LADDER.indexOf(q));
        else { worst = Math.max(worst, LADDER.indexOf(q)); bumpAny = true; }
        if (!(q === '2-3 days' || (q === '5-7 days' && l.getAttribute('data-ltl') === '1'))) allFast = false;
      }
      /* The ERP moves no add-on while a main item itself waits (sentinel main_item): if any
         main line is not fast here, the held add-ons count exactly as before, as in the Liquid. */
      var sep = [];
      for (var h = 0; h < held.length; h++) {
        if (!allFast) { worst = Math.max(worst, LADDER.indexOf(held[h].q)); bumpAny = true; }
        else if (held[h].rule === 'separate' && LADDER.indexOf(held[h].q) !== -1) sep.push(held[h]);
      }
      var freight = el.getAttribute('data-ks-freight') === '1';
      /* Freight map (Keelan 09-27), same as the Liquid: 2-3/3-5 -> 5-7, 5-7 -> 7-10,
         7-10 -> 10-14, slower unchanged. */
      if (freight && bumpAny) worst = worst < 2 ? 2 : (worst === 2 ? 3 : (worst === 3 ? 4 : worst));
      worst = Math.max(worst, soloWorst);
      if (worst > LADDER.indexOf(el.getAttribute('data-ks-main'))) continue;   // only ever faster
      var label = LADDER[worst] + (freight ? ' (Freight)' : '');
      var color = (freight ? worst === 2 : allFast) ? '#1e8449' : '';   /* freight: green only on 5-7 */
      if (el.textContent !== label) el.textContent = label;   /* unchanged = no DOM write, so */
      if (el.style.color !== (color ? 'rgb(30, 132, 73)' : '')) el.style.color = color;   /* the observer cannot loop */
      /* Same as the Liquid: one row per separate add-on, label left, its window right (Keelan 10-14). */
      var shown = groupAddons(sep.filter(function (a) { return LADDER.indexOf(a.q) > worst; }));
      var box = el.parentNode.nextElementSibling;
      if (!box || !box.hasAttribute('data-ks-cart-addon-rows')) continue;
      var key = shown.map(function (a) { return a.name + '|' + a.q; }).join(';');
      if (box.getAttribute('data-ks-key') === key) continue;
      box.setAttribute('data-ks-key', key);
      box.textContent = '';
      for (var k = 0; k < shown.length; k++) {
        var row = document.createElement('div');
        row.className = box.getAttribute('data-row-class');
        var a = document.createElement('span'), b = document.createElement('span');
        a.textContent = shown[k].name;
        b.textContent = shown[k].q;
        row.appendChild(a); row.appendChild(b);
        box.appendChild(row);
      }
    }
  }

  /* Two free IP lookups, tried in order, 2.5s each. Deliberately not the
     browser geolocation prompt - east or west does not justify a dialog. */
  function detect() {
    var sources = ['https://get.geojs.io/v1/ip/geo.json', 'https://ipwho.is/'];
    function tryOne(i) {
      if (i >= sources.length) return Promise.resolve(null);
      var ctl = new AbortController();
      var timer = setTimeout(function () { ctl.abort(); }, 2500);
      return fetch(sources[i], { signal: ctl.signal, credentials: 'omit', mode: 'cors' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          clearTimeout(timer);
          if (!j) return tryOne(i + 1);
          if (j.country_code && j.country_code !== 'US') return null;
          var code = String(j.region_code || '').trim().toUpperCase();
          if (!/^[A-Z]{2}$/.test(code)) return tryOne(i + 1);
          return { code: code, name: j.region || '', manual: false, ts: Date.now() };
        })
        .catch(function () { clearTimeout(timer); return tryOne(i + 1); });
    }
    return tryOne(0);
  }

  function run() {
    if (!document.querySelector(SEL) && !document.querySelector('[data-ks-cart-line]')) return;   // nothing regional on the page, no lookup
    var stored = read();   /* re-read each pass: a state picked on the product page reaches the cart live */
    if (stored) { region = stored.code; apply(); return; }
    if (region) { apply(); return; }
    if (detecting) return;
    detecting = true;
    detect().then(function (d) {
      detecting = false;
      if (!d) return;
      try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {}
      region = d.code;
      apply();
    });
  }

  run();
  document.addEventListener('DOMContentLoaded', run);

  // Cards also arrive after load - search, recommendations, infinite scroll.
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; run(); }, 100);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
